module.exports = __webpack_public_path__ + "img/m-contact-banner.12d148f9.webp";